import React, { useState } from 'react'

function PolicyReturn() {

    const [activeTab, setActiveTab] = useState(0);

    const handleTabClick = (tabIndex) => {
      setActiveTab(tabIndex);
    };


  return (
    <div className="policy-container tab-container">
          <div className="flex flex-col items-center p-3 w-full">
            <div className="flex justify-center w-full btn-container">
              {["marketed by", "return policy", "place return request"].map(
                (item, index) => (
                  <button
                    key={index}
                    onClick={() => handleTabClick(index)}
                    className={`tab-button ${
                      activeTab === index
                        ? "bg-neutral-400 text-black"
                        : "bg-gray-200"
                    } cursor-pointer font-medium text-xs  w-1/3 py-2 px-2 capitalize font-primaryFont ${
                      index === 0
                        ? "rounded-tl-lg"
                        : index === 2
                        ? "rounded-tr-lg"
                        : ""
                    }`}
                  >
                    {item}
                  </button>
                )
              )}
            </div>
            <div className="w-full">
              <div className="border-gray-300 p-4 border border-t-0 rounded-b-lg w-full font-primaryFont tab-content">
                <div
                  id="tab1-content"
                  className={`tab-pane ${activeTab === 0 ? "" : "hidden"}`}
                >
                  <p className="font-bold text-xs">Snitch Apparels Pvt. Ltd.</p>
                  <p className="text-xs">
                    No. 1/1, St. Johns Church Road, Bharathinagar, Bengaluru -
                    560005
                  </p>

                  <p className="mt-2 font-bold text-xs">Country of Origin:</p>
                  <p className="text-xs">India</p>
                </div>
                <div
                  id="tab2-content"
                  className={`tab-pane ${activeTab === 1 ? "" : "hidden"}`}
                >
                  <p className="text-xs leading-5">
                    We offer 7 days hassle-free returns. Return Policies may
                    vary based on products and promotions.
                    <br />
                    1) Refunds for Prepaid orders would directly be initiated to
                    source account and COD order will be refunded in the form of
                    COUPON CODE ONLY
                    <br />
                    2) Defective Products, Wrong Products or Damaged Products
                    issue should be raised within 24 hrs of delivery
                    <br />
                    3) All Orders wherein FREE Products included are not
                    eligible for Return
                    <br />
                    For more details on our Returns Policies, please{" "}
                    <a href="" className="font-bold">
                      click here
                    </a>
                    ․
                  </p>
                </div>
                <div
                  id="tab3-content"
                  className={`tab-pane ${activeTab === 2 ? "" : "hidden"}`}
                >
                  <p className="text-xs">
                    To place any Returns Request,{" "}
                    <a href="" className="font-bold">
                      click here
                    </a>
                    .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
  )
}

export default PolicyReturn